module.exports = "/_next/static/images/next_investments_mobile-2948449d2003f0c6cf0ebfac00824d51.jpeg";